module.exports = __webpack_public_path__ + "static/media/bo.15397e4c.svg";